interface Data {
  invoice: string;
  status: string;
  amount: number;
  date: string;
  action: any;
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

export const tableHeadData: readonly HeadCell[] = [
  {
    id: "invoice",
    numeric: false,
    disablePadding: true,
    label: "INVOICE NO",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "STATUS",
  },
  {
    id: "amount",
    numeric: false,
    disablePadding: false,
    label: "AMOUNT",
  },
  {
    id: "date",
    numeric: true,
    disablePadding: false,
    label: "DATE",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "ACTION",
  },
];
export const basicTableData = [
  {
    id: 1,
    invoice: "8959-962",
    status: "Pending",
    amount: 698,
    date: "08/09/2021",
  },
  {
    id: 2,
    invoice: "6434-393",
    status: "Pending",
    amount: 277,
    date: "24/05/2021",
  },
  {
    id: 3,
    invoice: "5016-631",
    status: "Reject",
    amount: 1488,
    date: "31/10/2020",
  },
  {
    id: 4,
    invoice: "9283-546",
    status: "Successful",
    amount: 1686,
    date: "10/10/2021",
  },
  {
    id: 5,
    invoice: "7354-331",
    status: "Successful",
    amount: 291,
    date: "03/05/2021",
  },
  {
    id: 6,
    invoice: "9296-037",
    status: "Successful",
    amount: 1017,
    date: "31/08/2021",
  },
  {
    id: 7,
    invoice: "6651-238",
    status: "Pending",
    amount: 1514,
    date: "03/02/2021",
  },
  {
    id: 8,
    invoice: "3525-970",
    status: "Pending",
    amount: 663,
    date: "12/03/2021",
  },
  {
    id: 9,
    invoice: "9954-093",
    status: "Reject",
    amount: 1672,
    date: "13/09/2021",
  },
  {
    id: 10,
    invoice: "5400-845",
    status: "Reject",
    amount: 318,
    date: "24/03/2021",
  },
  {
    id: 11,
    invoice: "1846-985",
    status: "Successful",
    amount: 1712,
    date: "04/05/2021",
  },
  {
    id: 12,
    invoice: "1781-063",
    status: "Pending",
    amount: 859,
    date: "22/03/2021",
  },
  {
    id: 13,
    invoice: "8382-120",
    status: "Reject",
    amount: 1009,
    date: "23/01/2021",
  },
  {
    id: 14,
    invoice: "8579-812",
    status: "Pending",
    amount: 1660,
    date: "03/04/2021",
  },
  {
    id: 15,
    invoice: "3060-418",
    status: "Successful",
    amount: 1573,
    date: "21/05/2021",
  },
  {
    id: 16,
    invoice: "8147-417",
    status: "Pending",
    amount: 1769,
    date: "03/12/2020",
  },
  {
    id: 17,
    invoice: "4671-521",
    status: "Pending",
    amount: 353,
    date: "02/11/2020",
  },
  {
    id: 18,
    invoice: "9954-917",
    status: "Pending",
    amount: 1820,
    date: "06/12/2020",
  },
  {
    id: 19,
    invoice: "6660-268",
    status: "Pending",
    amount: 1801,
    date: "31/12/2020",
  },
  {
    id: 20,
    invoice: "8037-349",
    status: "Pending",
    amount: 1957,
    date: "06/08/2021",
  },
  {
    id: 21,
    invoice: "3548-653",
    status: "Successful",
    amount: 1325,
    date: "13/08/2021",
  },
  {
    id: 22,
    invoice: "2321-697",
    status: "Successful",
    amount: 324,
    date: "22/05/2021",
  },
  {
    id: 23,
    invoice: "8651-974",
    status: "Successful",
    amount: 1322,
    date: "21/02/2021",
  },
  {
    id: 24,
    invoice: "5791-163",
    status: "Successful",
    amount: 1453,
    date: "04/07/2021",
  },
  {
    id: 25,
    invoice: "5900-970",
    status: "Reject",
    amount: 1382,
    date: "03/02/2021",
  },
  {
    id: 26,
    invoice: "1124-098",
    status: "Reject",
    amount: 395,
    date: "27/09/2021",
  },
  {
    id: 27,
    invoice: "1722-795",
    status: "Reject",
    amount: 1977,
    date: "11/11/2020",
  },
  {
    id: 28,
    invoice: "4809-240",
    status: "Reject",
    amount: 1479,
    date: "14/10/2020",
  },
  {
    id: 29,
    invoice: "6443-366",
    status: "Pending",
    amount: 1679,
    date: "17/11/2020",
  },
  {
    id: 30,
    invoice: "7877-808",
    status: "Pending",
    amount: 1676,
    date: "17/05/2021",
  },
  {
    id: 31,
    invoice: "2614-347",
    status: "Pending",
    amount: 1322,
    date: "23/10/2020",
  },
  {
    id: 32,
    invoice: "5881-020",
    status: "Pending",
    amount: 1144,
    date: "02/05/2021",
  },
  {
    id: 33,
    invoice: "2790-269",
    status: "Pending",
    amount: 1889,
    date: "25/12/2020",
  },
  {
    id: 34,
    invoice: "1278-633",
    status: "Pending",
    amount: 715,
    date: "17/02/2021",
  },
  {
    id: 35,
    invoice: "2249-730",
    status: "Reject",
    amount: 1129,
    date: "01/09/2021",
  },
  {
    id: 36,
    invoice: "5541-330",
    status: "Reject",
    amount: 1182,
    date: "25/09/2021",
  },
  {
    id: 37,
    invoice: "2220-396",
    status: "Pending",
    amount: 1484,
    date: "17/10/2020",
  },
  {
    id: 38,
    invoice: "4023-975",
    status: "Successful",
    amount: 1334,
    date: "19/07/2021",
  },
  {
    id: 39,
    invoice: "3977-715",
    status: "Successful",
    amount: 1116,
    date: "04/10/2021",
  },
  {
    id: 40,
    invoice: "5323-674",
    status: "Successful",
    amount: 1394,
    date: "02/10/2021",
  },
  {
    id: 41,
    invoice: "8475-919",
    status: "Successful",
    amount: 745,
    date: "02/04/2021",
  },
  {
    id: 42,
    invoice: "6562-566",
    status: "Successful",
    amount: 1191,
    date: "21/10/2020",
  },
  {
    id: 43,
    invoice: "9401-884",
    status: "Successful",
    amount: 1084,
    date: "09/08/2021",
  },
  {
    id: 44,
    invoice: "7386-085",
    status: "Successful",
    amount: 960,
    date: "02/10/2021",
  },
  {
    id: 45,
    invoice: "6590-578",
    status: "Successful",
    amount: 1826,
    date: "08/09/2021",
  },
  {
    id: 46,
    invoice: "3830-083",
    status: "Successful",
    amount: 836,
    date: "14/01/2021",
  },
  {
    id: 47,
    invoice: "7141-679",
    status: "Pending",
    amount: 940,
    date: "24/08/2021",
  },
  {
    id: 48,
    invoice: "6340-749",
    status: "Pending",
    amount: 1922,
    date: "03/01/2021",
  },
  {
    id: 49,
    invoice: "8460-752",
    status: "Pending",
    amount: 943,
    date: "08/04/2021",
  },
  {
    id: 50,
    invoice: "3821-094",
    status: "Pending",
    amount: 182,
    date: "15/10/2020",
  },
];
